export default "__VITE_ASSET__B$IlURA9__"